/**
 * Parsea referencias tipo "Juan 3:16", "Gn 1:1", "Génesis 1".
 * @returns {{ bookQuery: string, chapter: number, verse: number|null }|null}
 */
export function parseBibleReference(raw) {
  const q = String(raw || '').trim().replace(/\s+/g, ' ');
  if (!q) return null;
  // Libro + capítulo[:versículo]  |  Libro capítulo versículo
  const m = q.match(/^(.+?)\s+(\d{1,3})(?:\s*[:.,]\s*(\d{1,3})|\s+(\d{1,3}))?\s*$/i);
  if (!m) return null;
  const bookQuery = m[1].trim();
  const chapter = Number(m[2]);
  const verse = m[3] != null ? Number(m[3]) : (m[4] != null ? Number(m[4]) : null);
  if (!bookQuery || !Number.isFinite(chapter) || chapter < 1) return null;
  if (verse != null && (!Number.isFinite(verse) || verse < 1)) return null;
  return { bookQuery, chapter, verse };
}

const BOOK_ALIASES = {
  gn: 'GEN', gen: 'GEN', genesis: 'GEN', génesis: 'GEN',
  ex: 'EXO', exo: 'EXO', exodo: 'EXO', éxodo: 'EXO',
  lv: 'LEV', lev: 'LEV', levitico: 'LEV', levítico: 'LEV',
  nm: 'NUM', num: 'NUM', numeros: 'NUM', números: 'NUM',
  dt: 'DEU', deu: 'DEU', deuteronomio: 'DEU',
  jos: 'JOS', josue: 'JOS', josué: 'JOS',
  jue: 'JDG', jdg: 'JDG', jueces: 'JDG',
  rt: 'RUT', rut: 'RUT',
  '1s': '1SA', '1sa': '1SA', '1samuel': '1SA',
  '2s': '2SA', '2sa': '2SA', '2samuel': '2SA',
  '1r': '1KI', '1ki': '1KI', '1reyes': '1KI',
  '2r': '2KI', '2ki': '2KI', '2reyes': '2KI',
  '1cr': '1CH', '1ch': '1CH', '1cronicas': '1CH', '1crónicas': '1CH',
  '2cr': '2CH', '2ch': '2CH', '2cronicas': '2CH', '2crónicas': '2CH',
  esd: 'EZR', ezr: 'EZR', esdras: 'EZR',
  neh: 'NEH', nehemias: 'NEH', nehemías: 'NEH',
  est: 'EST', ester: 'EST',
  job: 'JOB',
  sal: 'PSA', psa: 'PSA', salmo: 'PSA', salmos: 'PSA',
  pr: 'PRO', pro: 'PRO', proverbios: 'PRO',
  ec: 'ECC', ecc: 'ECC', eclesiastes: 'ECC', eclesiastés: 'ECC',
  cnt: 'SNG', sng: 'SNG', cantares: 'SNG',
  is: 'ISA', isa: 'ISA', isaias: 'ISA', isaías: 'ISA',
  jer: 'JER', jeremias: 'JER', jeremías: 'JER',
  lm: 'LAM', lam: 'LAM', lamentaciones: 'LAM',
  ez: 'EZK', ezk: 'EZK', ezequiel: 'EZK',
  dn: 'DAN', dan: 'DAN', daniel: 'DAN',
  os: 'HOS', hos: 'HOS', oseas: 'HOS',
  jl: 'JOL', jol: 'JOL', joel: 'JOL',
  am: 'AMO', amo: 'AMO', amos: 'AMO', amós: 'AMO',
  abd: 'OBA', oba: 'OBA', abdias: 'OBA', abdías: 'OBA',
  jon: 'JON', jonas: 'JON', jonás: 'JON',
  mi: 'MIC', mic: 'MIC', miqueas: 'MIC',
  na: 'NAH', nah: 'NAH', nahum: 'NAH', nahúm: 'NAH',
  hab: 'HAB', habacuc: 'HAB',
  sof: 'ZEP', zep: 'ZEP', sofonias: 'ZEP', sofonías: 'ZEP',
  hg: 'HAG', hag: 'HAG', hageo: 'HAG',
  zac: 'ZEC', zec: 'ZEC', zacarias: 'ZEC', zacarías: 'ZEC',
  mal: 'MAL', malaquias: 'MAL', malaquías: 'MAL',
  mt: 'MAT', mat: 'MAT', mateo: 'MAT',
  mc: 'MRK', mrk: 'MRK', marcos: 'MRK',
  lc: 'LUK', luk: 'LUK', lucas: 'LUK',
  jn: 'JHN', jhn: 'JHN', juan: 'JHN',
  hch: 'ACT', act: 'ACT', hechos: 'ACT',
  ro: 'ROM', rom: 'ROM', romanos: 'ROM',
  '1co': '1CO', '1cor': '1CO', '1corintios': '1CO',
  '2co': '2CO', '2cor': '2CO', '2corintios': '2CO',
  gl: 'GAL', gal: 'GAL', galatas: 'GAL', gálatas: 'GAL',
  ef: 'EPH', eph: 'EPH', efesios: 'EPH',
  fil: 'PHP', php: 'PHP', filipenses: 'PHP',
  col: 'COL', colosenses: 'COL',
  '1ts': '1TH', '1th': '1TH', '1tes': '1TH', '1tesalonicenses': '1TH',
  '2ts': '2TH', '2th': '2TH', '2tes': '2TH', '2tesalonicenses': '2TH',
  '1tm': '1TI', '1ti': '1TI', '1tim': '1TI', '1timoteo': '1TI',
  '2tm': '2TI', '2ti': '2TI', '2tim': '2TI', '2timoteo': '2TI',
  tit: 'TIT', tito: 'TIT',
  fm: 'PHM', phm: 'PHM', filemon: 'PHM', filemón: 'PHM',
  he: 'HEB', heb: 'HEB', hebreos: 'HEB',
  st: 'JAS', jas: 'JAS', santiago: 'JAS',
  '1p': '1PE', '1pe': '1PE', '1pedro': '1PE',
  '2p': '2PE', '2pe': '2PE', '2pedro': '2PE',
  '1jn': '1JN', '1j': '1JN', '1juan': '1JN',
  '2jn': '2JN', '2juan': '2JN',
  '3jn': '3JN', '3juan': '3JN',
  jud: 'JUD', judas: 'JUD',
  ap: 'REV', rev: 'REV', apocalipsis: 'REV',
};

function normalizeKey(s) {
  return String(s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '');
}

/** Resuelve un libro del catálogo por código, nombre o alias. */
export function findBibleBook(books, bookQuery) {
  const rows = Array.isArray(books) ? books : [];
  const raw = String(bookQuery || '').trim();
  if (!raw || !rows.length) return null;
  const upper = raw.toUpperCase();
  const byCode = rows.find((b) => String(b.code || '').toUpperCase() === upper);
  if (byCode) return byCode;
  const key = normalizeKey(raw);
  const aliasCode = BOOK_ALIASES[key] || BOOK_ALIASES[raw.toLowerCase()];
  if (aliasCode) {
    const hit = rows.find((b) => String(b.code || '').toUpperCase() === aliasCode);
    if (hit) return hit;
  }
  const exact = rows.find((b) => normalizeKey(b.name) === key);
  if (exact) return exact;
  const starts = rows.find((b) => normalizeKey(b.name).startsWith(key) || key.startsWith(normalizeKey(b.name)));
  if (starts) return starts;
  return rows.find((b) => normalizeKey(b.name).includes(key)) || null;
}
